import { useState } from "react";
import { Field, reduxForm } from "redux-form";
import { Navigate, Link, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode"

import Loader from "../../../../shared_components/Loader";

import { renderInputField } from "../../../../shared_components/ReduxFormFields";
import { required } from "../../../../utils/validators";
import { ReactComponent as Code } from "../../../../assets/images/code_1.svg";
import { ReactComponent as GoogleLogo } from "../../../../assets/images/google.svg";
import "./style.scss";
import BackgroundCarousels from "./BackgroundCarousels";

const Login = ({ reset, handleSubmit, submitting, loginUser, authCheck }) => {
  const navigate = useNavigate();
  const { currentUserLoading } = useSelector((state) => state.user);
  const [userDetails, setUserDetails] = useState();
  const [error, setError] = useState("");

  const onSubmit = (values) => {
    const user = { ...values };

    loginUser(user).then((res) => {
      if (res?.success || res?.data?.success) {
        setError("");
        setUserDetails(res?.data);
      } else {
        setError(res?.message || res?.data?.message);
      }
    });
    reset("loginForm");
  };

  const responseSuccessGoogle = (credentialResponse) => {
    if (credentialResponse && credentialResponse.credential) {
      const decodedToken = jwtDecode(credentialResponse.credential);
      // user formate required for backend
      const googleUser = {
        givenName: decodedToken.given_name,
        familyName: decodedToken.family_name,
        email: decodedToken.email,
        imageUrl: decodedToken.picture,
        googleId: decodedToken.sub,
      };
      authCheck(googleUser).then(({ data }) => {
        if ({ data }) {
          setUserDetails(data);
        }
      });
    }
  };

  const handleGoogleLoginError = () => {
    setError("Google login failed. Please try again.");
  };

  return (
    <>
      {userDetails && !error && <Navigate to="/quiz" />}
      <div className="row mx-0 px-0 d-flex justify-content-center align-items-center login-bg">
        {/* <div className="col-12 col-md-8 img-section p-5">
          <div className="p-4">
            <Code width="500px" height="500px" />
          </div>
        </div> */}

        {/* <h1 className="text-gradient fw-bold my-2 d-flex justify-content-center align-items-center">
            Quiz Studio
          </h1>
     */}
        {/* BACKGROUND CAROUSELS */}
        <BackgroundCarousels />

        {/* login card */}
        <div className="col-10 col-md-4 login-card p-4 p-md-4 mt-md-5 shadow-lg">
          {currentUserLoading ? (
            <Loader />
          ) : (
            <>
              <div className="pt-2 px-md-4 px-0">
                <h1 className="text-center fw-bold text-gradient">
                  Log in To Get Inside
                </h1>
                <p className="text-muted text-center mb-4">Enter your credentials to access Quiz Studio</p>
                <GoogleOAuthProvider
                  // This Id prepated from datacode.in@gmail.com
                  clientId="974670448348-ki5ic34vj3putiddm97mpec8och9aft7.apps.googleusercontent.com"
                >
                  <GoogleLogin
                    className="btn-google"
                    onSuccess={responseSuccessGoogle}
                    onError={handleGoogleLoginError}
                    useOneTap
                    cookiePolicy={"single_host_origin"}
                    isSignedIn={true}
                    render={(renderProps) => (
                      <button
                        type="button"
                        className="btn text-dark btn-google"
                        onClick={renderProps.onClick}
                        disabled={renderProps.disabled}
                      >
                        <GoogleLogo width="20" height="20" className="me-2" />
                        <span className="text-primary">Log in with Google</span>
                      </button>
                    )}
                  />
                </GoogleOAuthProvider>
                <div className="divider my-4">
                  <span>or</span>
                </div>
                {error && <p className="text-danger">{error}</p>}
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div>
                    <Field
                      name="email"
                      type="text"
                      component={renderInputField}
                      label="Username or Email"
                      placeholder="system123"
                      validate={[required]}
                    />
                    <Field
                      name="password"
                      type="password"
                      component={renderInputField}
                      label="Password"
                      placeholder="******"
                      validate={[required]}
                    />
                  </div>
                  <div className="row mt-4">
                    <div className="col-12 px-0">
                      <div className="row mx-0 d-flex justify-content-between">
                        <div className="col-8">
                          <span className="signup-string p-0">
                            Don't have an account ?{" "}
                          </span>
                          <span>
                            <Link
                              to="https://datacode.in/signup"
                              className="link-purple"
                            >
                              Sign Up
                            </Link>
                          </span>
                        </div>
                        <div className="col-4 px-0">
                          <span>
                            <Link
                              to="https://datacode.in/forgot_password"
                              className="link-purple small"
                            >
                              Forgot Password?
                            </Link>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 py-4">
                      <button
                        type="submit"
                        className="btn w-100 text-white btn-gradient"
                        disabled={submitting}
                      >
                        Login
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default reduxForm({
  form: "loginForm", // a unique name for this form
})(Login);
